import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { useAuth } from "../hooks/useAuth";
import { customStylesModal } from "./ConfirmModal";
import { useTheme } from "../hooks/useTheme";
import { Button, ButtonSize } from "./Button";
import { ButtonVariant } from "../config/colors";
import { plebsRepository } from "../repositories/PlebsRepository";
import { APP_NAME } from "../config/app";

const HouseRulesModal = () => {
    const [isOpen, setIsOpen] = useState(false);
    const {pleb} = useAuth();
    const isMobile = useTheme();

    useEffect(() => {
        if(pleb && !pleb?.houseRulesAccepted) {
            setIsOpen(true);
        }
    }, [pleb]);

    const agreeHouseRules = () => {
        setIsOpen(false);
        plebsRepository?.updateUser({
            houseRulesAccepted: true
        });
    }

    const customStyles = customStylesModal('600px', isMobile ? true : false);

    if(customStyles.content) {
        customStyles.content.maxHeight = '100%';
        customStyles.content.display = 'flex';
        customStyles.content.flexDirection = 'column';
        customStyles.content.justifyContent = 'space-between';
    }

  return (
    <Modal 
        isOpen={isOpen} 
        style={customStyles}
    >
      <div className="flex flex-col gap-6 p-6">
        <div className="flex flex-col gap-6 overflow-y-auto">
            <div>
                <h1 className="text-2xl font-bold mb-4">Welcome To {APP_NAME}!</h1>
                <h2 className="text-lg">Before you dive in, here are our House Rules.</h2>
            </div>
            <div>
                <p className="font-bold text-brand-orange">No Scamming.</p>
                <p>This one should be obvious. Zero tolerance.</p>
            </div>
            <div>
                <p className="font-bold text-brand-orange">No Spamming.</p>
                <p>We love that you have a Bitcoin Podcast, Newsletter, or Project, but Group Chats are not your personal billboard. Share value, not noise.</p>
            </div>
            <div>
                <p className="font-bold text-brand-orange">No Shitcoining.</p>
                <p>This app was made by Bitcoiners for Bitcoiners. We know you might hold other coins, that’s your business. But this is not the place to promote or discuss them.</p>
            </div>
            <div>
                <p className="font-bold text-brand-orange">Be Cool.</p>
                <p>Respect each other. Keep conversations high-signal. You’re here to find your local Bitcoin tribe and build the strongest Bitcoin community on the planet.</p>
            </div>
        </div>
        <Button 
            onClick={agreeHouseRules} 
            size={ButtonSize.medium} 
            variant={ButtonVariant.primary}
            className="shrink-0"
        >
            I Agree
        </Button>
      </div>
    </Modal>
  );
};

export default HouseRulesModal;